import { useState } from "react";
import deleteRequestInterface from "utilFunctions/Axios/deleteRequestInterface";
import { deleteAPI } from "../Axios/AxiosRequestConfiguration";
export interface deleteInterface {
  onSuccess: (data: any) => void;
  onError: (error: any) => void;
  method: string;
}
const useDeleteData = (
  onSuccess: (data: any) => void,
  onError: (error: any) => void,
  method: string
) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [responseData, setResponseData] = useState<any>(null);
  const makeRequest = async (url: string) => {
    setLoading(true);
    deleteAPI({
      url: url,
      success: (data: any) => {
        setResponseData(data["data"]);
        onSuccess(data["data"]);
        setLoading(false);
      },
      failure: (err: any) => {
        setLoading(false);
        setError(err);
        onError(err);
      },
      method: method,
    } as deleteRequestInterface);
  };

  return { makeRequest, loading, responseData, error };
};
export default useDeleteData;
